/** Application automation action ids (see Palaute.actions.applicant_actions). */
export const AUTOMATION_ACTION_ADD_TAG = 'add-tag-to-application';
export const AUTOMATION_ACTION_SEND_EMAIL_APPLICATION = 'send-email-to-application';
export const AUTOMATION_ACTION_SEND_EMAIL_COLLABORATORS = 'send-email-to-collaborators';
export const AUTOMATION_ACTION_SET_STEP = 'set-application-step';
